import { getSharedBodyStyles } from './shared';
import getColumnsStyles from './columns';

export default (components, { palette }) => ({
  ...getSharedBodyStyles(components, { palette }),

  // not directly use '& tr' as key here, since it might override the shared style
  // CCUI doesn't have the leading Status column, so this part is not migrated
  '& tr.aggregated-row:hover td': {
    '&:first-child, &:nth-child(2), &:last-child': {
      borderRight: 'none',
    },
  },
  '& tr:hover, & tr.row-selected, & tr.row-selected:hover': {
    '& td': {
      '&:first-child, &:nth-child(2), &:last-child': {
        borderRight: 'none',
      },
    },
  },
  '& tr.row-selected td.grid-column-Delivery': {
    '& .status-warning, & .iconba-Warning': {
      color: '#8E562E',
    },
  },
  '& tr td': getColumnsStyles(components, { palette }),
  '& tr.row-selected td': {
    '&.grid-column-Campaign, &.col-CampaignName': {
      '& a.experiment-name': {
        color: palette.themeDarker,
      },
    },
  },
});
